import Button from '@mui/material/Button';
import { Download } from 'react-feather';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { SBOMContext } from '../../../pages/NRSBOMTable/NRSBOMDataShare';

function SBOMButton() {
  const theme = useTheme();
  const { openDownloadSBOM, setOpenDownloadSBOM } = useContext(SBOMContext);

  const handleClick = () => {
    setOpenDownloadSBOM(true);
  };

  return (
    <Box id="sbom-download-buttons">
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        variant="outlined"
        color="secondary"
        startIcon={<Download size={18} />}
        aria-expanded={openDownloadSBOM ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform: 'none',
          height: theme.spacing(4.5)
        }}
      >
        <Typography variant="subtitle2" component="span">
          Download SBOM
        </Typography>
      </Button>
    </Box>
  );
}

export default SBOMButton;
